import {Vector3} from '@babylonjs/core/Maths/math.vector.js';
import {ShadowGenerator} from '@babylonjs/core/Lights/Shadows/shadowGenerator.js';
import {Assets} from './assets';
import {height,buildings,localPoint} from './world';
export class Environment{
 private lod0;private lod1;private monument;private activeLod=0;private near=true;hideDecor=false;
 private expanded:{data:typeof buildings[number];variants:ReturnType<Assets['instantiate']>[];parts:ReturnType<Assets['instantiate']>[];lod:number;visible:boolean}[]=[];
 private center=new Vector3(14,4.4,8);
 constructor(private assets:Assets,private shadows:ShadowGenerator){
  this.lod0=assets.instantiate('elmir_house_residential_01',14,8,height(14,8));
  this.lod1=assets.instantiate('elmir_house_residential_01_lod1',14,8,height(14,8));
  this.monument=assets.instantiate('elmir_central_monument_01',0,0,height(0,0));
  this.lod1.root.setEnabled(false);
  for(const b of buildings){
   const variants=[b.model,b.model+'_lod1'].map(name=>assets.instantiate(name as import('./assets').AssetName,b.x,b.z,height(b.x,b.z)));
   for(const v of variants)v.root.rotation.y=b.rotation;
   const parts=b.parts.map(p=>{const at=localPoint(b,p.position);const v=assets.instantiate(p.file.replace('.glb','') as import('./assets').AssetName,at.x,at.z,height(b.x,b.z)+p.position[1]);v.root.rotation.y=b.rotation+p.rotation_y;return v;});
   for(const v of [...variants,...parts]){v.root.setEnabled(false);for(const m of v.meshes)shadows.addShadowCaster(m);}
   this.expanded.push({data:b,variants,parts,lod:0,visible:false});
  }

  for(const m of [...this.lod0.meshes,...this.lod1.meshes,...this.monument.meshes])shadows.addShadowCaster(m);
 }
 update(camera:Vector3){
  for(const b of this.expanded){
   const d=Math.hypot(camera.x-b.data.x,camera.z-b.data.z);if(b.lod===0&&d>b.data.lodDistance+3)b.lod=1;else if(b.lod===1&&d<b.data.lodDistance-3)b.lod=0;
   // Single persistent owner per building. Bounding radius keeps the full temple visible across cells.
   b.visible=!this.hideDecor&&d<165;
   b.variants.forEach((v,i)=>v.root.setEnabled(b.visible&&i===b.lod));for(const v of b.parts)v.root.setEnabled(b.visible);
  }
  const distance=Vector3.Distance(camera,this.center);
  if(this.activeLod===0&&distance>37)this.activeLod=1;
  else if(this.activeLod===1&&distance<33)this.activeLod=0;
  // Two persistent placements, cached GLB containers; no chunk-driven re-imports.
  this.near=distance<165;
  const visible=this.near&&!this.hideDecor;
  this.lod0.root.setEnabled(visible&&this.activeLod===0);
  this.lod1.root.setEnabled(visible&&this.activeLod===1);
  this.monument.root.setEnabled(visible);
 }
 snapshot(){return {expansion:this.expanded.map(b=>({id:b.data.id,lod:b.lod,visible:b.visible,position:[b.data.x,0,b.data.z],variants:b.variants.map(v=>v.root.isEnabled()),parts:b.parts.length})),activeBuildings:this.expanded.filter(b=>b.visible).length,loadMs:this.assets.loadMs,houseLod0Enabled:this.lod0.root.isEnabled(),houseLod1Enabled:this.lod1.root.isEnabled(),resources:this.assets.resourceStats(),lod:this.activeLod,loading:this.assets.status,requests:this.assets.requests,visibleInstances:this.near&&!this.hideDecor?2:0,placements:2,houseVariants:2,housePosition:[14,0,8],monumentPosition:[0,0,0]};}
 dispose(){
  for(const instance of [this.lod0,this.lod1,this.monument,...this.expanded.flatMap(b=>[...b.variants,...b.parts])]){
   for(const m of instance.meshes)this.shadows.removeShadowCaster(m);instance.dispose();
  }
 }
}
